<script setup>
import { ref, onMounted } from 'vue'
import { urlConstants } from '@/core/urlConstants'
import { useQuoteStore } from '@/stores/quote';
import {useUserStore} from "@/stores/user";

const quoteStore = useQuoteStore();
const userStore = useUserStore()
const count = ref(5)
const url = resolveUrl();

function resolveUrl(){
  if(typeof urlConstants[quoteStore.category] !== 'undefined' && !userStore.isPanelIFrame()){
    return `${window.location.origin}${urlConstants[quoteStore.category]}`
  } else if (typeof urlConstants[quoteStore.category] !== 'undefined' && userStore.isPanelIFrame()) {
    return `${window.location.origin}${urlConstants['crm'+quoteStore.category]}`

  }

  return '/'
}


function increment() {
  if (count.value === 0) {
    count.value--
    window.location.href = url;
  } else if ( count.value > 0 ) {
    count.value--
  }
}

// lifecycle hooks
onMounted(() => {
  setInterval(increment, 1000)
})
</script>

<template>
  <div class="toast-text">Η συνεδρία σας έχει λήξει. Θα μεταφερθείτε στην φόρμα τιμολόγησης σε {{ count >= 0 ? count : 0}} δευτερόλεπτα ή πατήστε <a class="toast-url" :href="`${url}`">εδώ</a> για να μεταφερθείτε άμεσα</div>
</template>
